// U+2068 FIRST STRONG ISOLATE / U+2069 POP DIRECTIONAL ISOLATE.
// Wraps text so its internal bidi direction is isolated from the surrounding
// RTL paragraph. Use for Latin candidate/election names embedded in RTL prose.
export const isolate = (text: string): string => `⁨${text}⁩`;

// Props for the element holding a one-line value that reads left to right — a
// street address, an email — in a right-to-left layout. Laid out in the page's
// direction, the leading house number of "350 5th Avenue, New York, NY" rendered
// at the far end (staging QA, Urdu, September 2026). `dir="ltr"` keeps the
// value's own order and `end` keeps it on the layout's start side. A value too
// long for its line still truncates at its end, so the house number stays in
// view; an LTR isolate inside the RTL line would clip the start instead.
// (The mobile app isolates the text: native truncation cuts characters, not
// pixels.)
export const ltrValueProps = (pageDir: 'ltr' | 'rtl') =>
  pageDir === 'rtl' ? ({ dir: 'ltr', style: { textAlign: 'end' } } as const) : {};
